import { CalculateFestival } from '@/domain/impact-calculate-festival/entities/calculate-festival.entity';
import { EMPTY_CALCULATE_FESTIVAL_CO2 } from '@/domain/impact-calculate-festival/entities/calculate-festival-co2.entity';
import { EMPTY_CALCULATE_FESTIVAL_ENV } from '@/domain/impact-calculate-festival/entities/calculate-festival-env.entity';
import { EMPTY_CALCULATE_FESTIVAL_ESS } from '@/domain/impact-calculate-festival/entities/calculate-festival-ess.entity';

import { TopicsGlobalScoreData } from '../entities/calculate.entity';

export function prepareTopicsGlobalScoreDataFestival(
  calculate: CalculateFestival | null,
): TopicsGlobalScoreData {
  const co2 = calculate?.co2 || EMPTY_CALCULATE_FESTIVAL_CO2;
  const env = calculate?.env || EMPTY_CALCULATE_FESTIVAL_ENV;
  const ess = calculate?.ess || EMPTY_CALCULATE_FESTIVAL_ESS;
  return {
    projectMode: 'festival',
    co2: {
      scoreLetter: co2.scoreLetter,
      score: co2.score,
      kgeCO2ByParticipant: co2.kgeCO2ByParticipant,
    },
    env: {
      scoreLetter: env.scoreLetter,
      score: env.score,
      maxScore: env.maxScore,
    },
    ess: {
      scoreLetter: ess.scoreLetter,
      score: ess.score,
      maxScore: ess.maxScore,
    },
  };
}
